import { render, staticRenderFns } from "./LoginCompany.vue?vue&type=template&id=5ed8f888&scoped=true&"
import script from "./LoginCompany.vue?vue&type=script&lang=js&"
export * from "./LoginCompany.vue?vue&type=script&lang=js&"
import style0 from "../../../public/assets/css/intern-dashboard.css?vue&type=style&index=0&id=5ed8f888&scoped=true&lang=css&"
import style1 from "./LoginCompany.vue?vue&type=style&index=1&id=5ed8f888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8f888",
  null
  
)

export default component.exports